module.exports = __webpack_public_path__ + "img/2.7e6e4f4e.jpg";